import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import Fallback from "components/Fallback";

import useFetchMapById from "services/hooks/useFetchMapById";
import useFetchMapsByAssetId from "services/hooks/maps/useFetchMapsByAssetId";

const RedirectMapAsset = ({ children }) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const entityId = searchParams.get("entityId") || "";
  const mapId = searchParams.get("mapId") || "";
  const assetId = searchParams.get("assetId") || "";

  const { isSuccess: isSuccessMap, isError: isErrorMap } = useFetchMapById(
    entityId,
    mapId
  );

  const {
    isSuccess: isSuccessMaps,
    data: maps,
    refetch,
  } = useFetchMapsByAssetId({
    entityId,
    assetId,
  });

  useEffect(() => {
    if (mapId && isErrorMap) {
      searchParams.delete("mapId");
      setSearchParams(searchParams);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mapId, isErrorMap]);

  useEffect(() => {
    if (!mapId && !isSuccessMaps) refetch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mapId, isSuccessMaps]);

  useEffect(() => {
    if (!mapId && isSuccessMaps) {
      searchParams.append("mapId", maps.data[0].id);
      setSearchParams(searchParams);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mapId, isSuccessMaps, maps]);

  return mapId && (isSuccessMap || isSuccessMaps) ? children : <Fallback />;
};

export default RedirectMapAsset;
